













































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import PendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import { Loading, Snackbar, IRequestMessage, RequestMessage, TipoDocumentoUpload, TipoMensagemEnum, PendenciaMensagem, TipoEnvioMensagemEnum } from '@/types/_'
import { PendenciaSolicitacao, IPendenciaSolicitacao } from '@/types/implements/PendenciaSolicitacao'
import moment from 'moment'
import { maskHour, isRolesValid, maskDate, groupCollectionByField, timeout, timeoutDefault } from '@/utils/common'

@Component

export default class ComponentPendenciaSolicitacaoLayout extends Vue {
  @Prop() display: any
  @Prop({ default: false }) hospital: boolean
  mensagem: string = ''
  inputFiles: any[] = []
  loadMensagem: boolean = false
  requestMessage: IRequestMessage = new RequestMessage()
  pendenciaSolicitacao: IPendenciaSolicitacao = new PendenciaSolicitacao()
  loadClose: boolean = false

  get getPendenciaStore() {
    return getModule(PendenciaStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(value: string) {
    this.mensagem = value
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(value: boolean) {
    this.loadMensagem = value
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  clearMensagem() {
    this.loadingMensagem = false
    this.getMensagem = ''
  }

  sendMensagem() {
    if (this.getMensagem) {
      this.loadingMensagem = true
      this.addMensagem(this.getMensagem)
    }
  }

  async inputFile(newFile, oldFile) {
    this.setLoadingRequest(this.requestMessage.status, this.requestMessage.post)
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm')

    const param: any = {
      hospitalId: this.getPendenciaStore.agendamentoMedico.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const request = await this.pendenciaSolicitacao.uploadDocumento(param)
    if (request.success) {
      const result = request.data[0]
      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: this.hospital,
        id: '',
        dataEnvio: moment().format('YYYY-MM-DDTHH:mm'),
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId: result.id,
        url: result.url,
        nomeArquivo: result.nomeArquivo,
      }

      const response = await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
      if (response.success) {
        this.getBackofficeAgendamentoStore.deleteSolicitacao(this.getPendenciaStore.pendencia.solicitacaoId)
      }
    }

    this.clearLoadingRequest()
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('l_scrollto_pendencia')
    const option: ScrollToOptions = {
      behavior: 'smooth',
      left: 0,
      top: ele[0].scrollHeight + 200,
    }
    ele[0].scrollTo(option)
  }

  updated() {
    this.scrollToMensagem()
  }

  @Emit('addMensagem')
  addMensagem(mensagem) { }

  @Emit('closeModalPendencia')
  async closeModalPendencia() {
    this.loadingClose = true
    await timeoutDefault()
    this.loadingClose = false
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }
}
